import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@core/services/http.service';
import { User } from '@features/reflex/models/user.model';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  message: 'INVALID_CREDENTIALS' | null;
  status: 'ERROR' | null;
  user: User | null;
}

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  private readonly http = inject(HttpService);
  private readonly BASE_PATH = 'logistica/auth';

  loginUser(credentials: LoginRequest): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${this.BASE_PATH}/login`, credentials);
  }

  getUser() {
    return this.http.get<User>(`${this.BASE_PATH}/user`);
  }
}
